import { useQuery } from '@tanstack/react-query';
import remoteDbService from '@/core/database/RemoteDBService';
import { type Collection } from '@/features/collections/types/collection.types';
import { type Page } from '@/features/pages/types/page.types';
import { publicKeys } from '@/shared/query/queryKeys';

type CollectionWithFirstPageData = {
  collection: Collection;
  firstPage: Page | null;
};

export const useCollectionWithFirstPage = (collectionId: string | undefined) => {
  return useQuery<CollectionWithFirstPageData>({
    queryKey: publicKeys.collectionFirstPage(collectionId),
    queryFn: async () => {
      if (!collectionId) throw new Error('Collection ID is required');
      return await remoteDbService.getCollectionByIdAndFirstPage(collectionId);
    },
    enabled: !!collectionId,
  });
};
